<script setup>
import { AisHierarchicalMenu } from "vue-instantsearch/vue3/es"
import HierarchicalMenuList from "@/Components/Algolia/HierarchicalMenuList.vue"
</script>

<template>
  <AisHierarchicalMenu
    v-bind="$attrs"
  >
    <template
      v-slot="{
      items,
      canToggleShowMore,
      isShowingMore,
      refine,
      toggleShowMore,
      createURL,
      sendEvent,
    }"
    >
      <HierarchicalMenuList
        :items="items"
        :refine="refine"
        :createURL="createURL"
      />
      <button
        class="text-sm text-indigo-500 hover:underline"
        @click.prevent="toggleShowMore()"
        v-if="canToggleShowMore"
      >
        {{ isShowingMore ? 'Show less' : 'Show more' }}
      </button>
    </template>
  </AisHierarchicalMenu>
</template>

